"use client";
import React from 'react';
import NextTopLoader from 'nextjs-toploader';

const ProgressbarWrapper = () => {
    return (
        <>
            <NextTopLoader height={3} color={"#ff774b"} showSpinner={false}/>
        </>
    );
};

export default ProgressbarWrapper;